<style scoped>
.three-column-layout {
	height: 100vh;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	padding: 10px;
}

.three-column-header {
	flex-shrink: 0;
}

.three-column-body {
	flex: 1;
	min-height: 0;
	display: flex;
	gap: 1rem;
	padding-bottom: 0.75rem;
}

.col-left,
.col-center,
.col-right {
	overflow-y: auto;
	min-height: 0;
}

.col-left {
	flex: 1 1 25%;
	min-width: 0;
}

.col-center {
	flex: 1 1 50%;
	min-width: 0;
}

.col-right {
	flex: 1 1 25%;
	min-width: 0;
}

/* Two-column variant: no #right slot — queue + a wider detail panel. The
   ratio is the caller's choice, defaulting to the review workbenches' 30/70. */
.three-column-layout.no-right-column.split-30-70 .col-left {
	flex: 1 1 30%;
}

.three-column-layout.no-right-column.split-30-70 .col-center {
	flex: 1 1 70%;
}

.three-column-layout.no-right-column.split-40-60 .col-left {
	flex: 1 1 40%;
}

.three-column-layout.no-right-column.split-40-60 .col-center {
	flex: 1 1 60%;
}
</style>
<script setup lang="ts">
/**
 * Two-column split used when no #right slot is given. "30-70" (narrow list,
 * wide detail) is the default the review workbenches use; a caller that wants
 * a wider left pane passes "40-60".
 */
withDefaults(defineProps<{ twoColumnSplit?: "30-70" | "40-60" }>(), {
	twoColumnSplit: "30-70",
});
</script>

<template>
	<div
		class="three-column-layout"
		:class="['split-' + twoColumnSplit, { 'no-right-column': !$slots.right }]"
	>
		<div class="three-column-header pb-3">
			<div class="row">
				<slot name="header"></slot>
			</div>
		</div>
		<div class="three-column-body">
			<div class="col-left">
				<slot name="left"></slot>
			</div>
			<div class="col-center">
				<slot name="center"></slot>
			</div>
			<div v-if="$slots.right" class="col-right">
				<slot name="right"></slot>
			</div>
		</div>
	</div>
</template>
